import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkModule } from './network/network.module';
import { NgxTagsInputModule } from 'ngx-tags-input';
import { IncludedInputComponent } from './components/included-input/included-input.component';
import { ExcludedInputComponent } from './components/excluded-input/excluded-input.component';

import { TagsComponent } from './tags-component/tags.component';
import { FacilitiesComponent } from './components/facilities-component/facilities.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TagInputModule } from 'ngx-chips';
import { MapComponent } from './map/map.component';
import { AgmCoreModule } from '@agm/core';
import { BaseReportingModule } from './base-reporting/base-reporting.module';
import { NotFoundComponent } from './not-found/not-found.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { SharedComponentsModule } from './components/shared-components.module';
import { DynamicValidatorsModule } from './helpers/dynamic-validators/dynamic-validators.module';
import { NgRepeatDirective } from './helpers/directives/ng-repeat/ng-repeat.directive';
import { NgUnlessDirective } from './helpers/directives/ng-unless/ng-unless.directive';
import { DropdownModule } from 'primeng/dropdown';

@NgModule({
    declarations: [
        TagsComponent,
        IncludedInputComponent,
        ExcludedInputComponent,
        FacilitiesComponent,
        MapComponent,
        NotFoundComponent,
        AccessDeniedComponent,
        NgRepeatDirective,
        NgUnlessDirective
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        NetworkModule,
        NgxTagsInputModule,
        DropdownModule,
        PaginationModule.forRoot(),
        TabsModule,
        TagInputModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBxSEF3Pkhg-mU97PSbLAVNgvMLOJhmBeU',
            libraries: ['places']
        }),
        BaseReportingModule,
        SharedComponentsModule,
        DynamicValidatorsModule
    ], exports: [
        TagsComponent,
        IncludedInputComponent,
        ExcludedInputComponent,
        FacilitiesComponent,
        MapComponent,
        BaseReportingModule,
        SharedComponentsModule,
        NotFoundComponent,
        AccessDeniedComponent,
        DynamicValidatorsModule,
        NgRepeatDirective
    ]

})
export class SharedModule { }
